export default __webpack_public_path__ + "static/media/truck.7778e7d8.svg";